<template>
  <div v-show="hotComment">
    <div class="recommend-bg">
      <p class="active-title">{{this.$t('common.Top')}}<span>{{this.$t('common.comments')}}</span></p>
      <!--<div class="ranking-img-bg">-->
      <!--<div class="ranking-img-title">-->
      <!--<span>MRT Pro数据恢复软件下载</span>-->
      <!--</div>-->
      <!--<img src="../assets/homepage/banner1.jpg" class="ranking-img">-->
      <!--</div>-->
      <ul class="ranking-list">
        <!--<router-link :to="{path:'/contentPage/'+items.articleId ,query: { url: 'article' }}" >-->
        <!--</router-link>-->
        <li v-for="(items,index) in commentContent" :key="index" @click="contentPage(items.articleId)">{{items.content}}</li>

      </ul>
    </div>

  </div>

</template>

<script>
  import axios from '@/axios'

  export default {
    name: "hotComment",
    data() {
      return {
        commentContent:[],
        routerAlive:true,
        hotComment:true
      }
    },
    components:{},
    created: function () {
      this.getCommentList();
    },
    methods: {
      // 热门评论请求数据
      getCommentList(){
        let _this = this;
        axios.get(this.$store.state.apiBasePath + "/comment/hot",{params: {size: 10}})
          .then(function (res) {
            if (res.data.code === 200) {
              let resData = res.data.data;
              if(resData.length==0){
                // _this.hotComment=false;
              }
              _this.commentContent=resData;
            }
          })
      },

      // 页面跳转
      contentPage(id) {
        //跳转新页面 url: this.url传入对应新闻列表参数
        let routeData = this.$router.resolve({path: "/contentPage/" + id,query: { url: 'article' } });
        // console.log(routeData);
        //点击跳转新页面
        window.open(routeData.href, '_blank');

        // this.$router.push({ path:"/contentPage/"+id ,query: { url: 'article' } })
      },
    },
 }
</script>

<style scoped>
  .recommend-bg {
    border: #e5e5e5 1px solid;
    margin-bottom: 10px;
    background: #fff;
  }
  .active-title {
    font-size: 20px;
    color: #000;
    text-align: left;
    padding: 5px 0;
    margin: 10px 10px;
    border-bottom: #ddd 1px solid;
  }

  .active-title span {
    color: #fe7201;
  }

  .ranking-list {
    margin-top: 10px;
    padding: 0 15px;

  }

  .ranking-list li {
    display: block;
    line-height: 28px;
    font-size: 14px;
    overflow: hidden;
    height: 28px;
    text-align: justify;
    color: #000;
  }

  .ranking-list li:hover {
    text-decoration: underline;
    color: #379ce9;
    cursor: pointer;
  }


</style>



// WEBPACK FOOTER //
// src/components/comment/hotComment.vue